import { render } from "./portworxVolume.vue?vue&type=template&id=5afaf44d"
import script from "./portworxVolume.vue?vue&type=script&lang=js"
export * from "./portworxVolume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__